import { useNavigate, useParams } from "react-router-dom";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import { useDispatch, useSelector } from "react-redux";
import {
  addtowishSellbyid,
  getSellById,
  insertRequestinProduct,
} from "../../../../redux/sale/action";
import { useEffect, useState } from "react";
import CustomReactQuillDescription from "../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import { Commas } from "../../../Common/AllDateTimeReleventFormate";
import Access from "../../../CustomComponents/Access/Access";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { useRouteBaseStateContext } from "../../../../Context/RouteBaseStateContext";
import { IS_LOGGED_IN_USER } from "../../../../assests/extention/commonfunction";
import ReactImageGalleryCompoment from "../SearchContestParticipate/ContestDetails/ReactImageGalleryCompoment";

export default function ProductDetails() {
  const laung = localStorage.getItem("laung");
  const path = "Assets/scss/FindWork.module.scss";
  const [lan, setLan] = useState(laung ?? "en");
  const [image, setImage] = useState([]);
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);

  const { setOTSroute } = useRouteBaseStateContext();
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const { id } = useParams();

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const dispatch = useDispatch();

  const getsalebyid = useSelector(({ sale: { getsalebyid } }) => getsalebyid);

  useEffect(() => {
    dispatch(getSellById(id));
  }, [id]);

  useEffect(() => {
    if (getsalebyid?.files) {
      setImage(getsalebyid?.files);
    }
  }, [getsalebyid, getsalebyid?.files]);

  const images =
    Array.isArray(image) &&
    image?.map((file) => ({
      original: file.file,
      thumbnail: file.file,
    }));

  const insertRequestinsaleproduct = () => {
    const data = {
      sale_id: id,
      type: "1",
    };
    // dispatch(insertRequestinProduct(data, id));
    // dispatch(getSellById(id));
    navigate(`/${lan}/salecontract/${id}`, {
      state: { approvefrom: "buyerfromlist", type: "sale", payload: data },
    });
    setModal(false);


  };


  const checkaccessss = () => {
    setModal(true);
  };

  const addtowishlist11 = (id) => {
    dispatch(addtowishSellbyid(id));
  };

  const handleNavigateToOTS = () => {
    navigate(`/${lan}/dashboard/myotsproducts?productid=${id}`)
    setOTSroute("ProductforSell")
  }

  return (
    <div className="col-lg-10   mx-auto project-details packageddetails">
      {modal ? (
        <Access
          modal={modal}
          setModal={setModal}
          // pathurl={`/${lan}/otscontract/${id}`}
          state={"state"}
          checkpermission={"purchase_sale"}
          hitmethod={insertRequestinsaleproduct}
          masterID={getsalebyid && getsalebyid.id}
          checkrole={false}
        />
      ) : (
        ""
      )}
      <p className="breadcrumbs">
        <a onClick={() => navigate(`/${laung}/searchbuyproducts`)}>BSM &gt; </a>
        {getsalebyid?.title}
      </p>
      <div className="col-lg-10 mx-auto">
        <div className="row">
          <div className="col-md-6 padding-rightwrapper">
            <ReactImageGalleryCompoment images={images} />
          </div>
          <div className="col-md-6 package-right">
            <h3>{getsalebyid?.title}</h3>
            <div className="price-duration">
              <div>
                <h6>Price</h6>
                <h2>$ {Commas(getsalebyid?.price)}</h2>
              </div>
            </div>
            <div className="price-duration">
              <div>
                <h6>
                  Industry
                </h6>
                <h2>
                  {getsalebyid.industry_title}
                </h2>
              </div>
              <div>
                <h6>Category</h6>
                <h2>{getsalebyid?.category_title}</h2>
              </div>
              {getsalebyid?.sub_category_title && <div>
                <h6>Sub - category</h6>
                <h2>{getsalebyid?.sub_category_title}</h2>
              </div>}
            </div>
            <div className="price-duration">
              <div>
                <h6>Country</h6>
                <h2>{getsalebyid?.country_title}</h2>
              </div>
              <div>
                <h6>Product Condition</h6>
                <h2>
                  {getsalebyid?.product_condition == 2 ? "Used" : "Brand New"}
                </h2>
              </div>
            </div>
            <div className="price-duration">
              <div>
                <h6>Shipping Charges</h6>
                <h2>
                  {getsalebyid?.shipping == 2 ? "Not Included" : "Included"}
                </h2>
              </div>
            </div>
            <div className="price-duration">
              <div>
                <h6>Description</h6>
                <h2>
                  {" "}
                  <CustomReactQuillDescription
                    value={getsalebyid.description}
                  />
                </h2>
              </div>
            </div>
            <div
              className="d-flex align-items-center mt-4"
              style={{ columnGap: "15px" }}
            >
              {getsalebyid?.is_mine == 1 ? (
                <button
                  className="btn purchase-btn w-100"
                  onClick={() => handleNavigateToOTS()}
                >
                  View details
                </button>
              ) : getsalebyid?.status == 1 ? (
                getsalebyid?.sale_request_id > 0 ? (
                  <button className="btn purchase-btn w-100 mt-4" disabled>
                    Request pending
                  </button>
                ) : (
                  <button
                    className="btn purchase-btn w-100 mt-4"
                    onClick={() => checkaccessss()}
                  >
                    Send request
                  </button>
                )
              ) : (
                getsalebyid?.sale_request_id > 0 ? (
                  <button className="btn purchase-btn w-100 mt-4" disabled>
                    Accepted
                  </button>
                ) : (
                  <button className="btn purchase-btn w-100 mt-4" disabled>
                    Sold out
                  </button>
                )
              )}

              {(getsalebyid?.status == 1 || getsalebyid?.is_mine == 1) && (
                <button
                  className="btn heart-btn"
                  style={{ background: "transparent", padding: "0" }}
                  onClick={() => {
                    if (IS_LOGGED_IN_USER) {
                      addtowishlist11(getsalebyid?.id, 1);
                    } else {
                      setModal(true);
                    }
                  }}
                >
                  {getsalebyid.wishlist == 1 ? (
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/project/heart-active.svg`}
                      alt=""
                    />
                  ) : (
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/project/heart.svg`}
                      alt=""
                    />
                  )}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
